export var INPUT_TYPE = {
    mouse: 'mouse',
    touch: 'touch'
};

export var ENLARGED_IMAGE_POSITION = {
    over: 'over',
    beside: 'beside'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-magnify/dist/es/constants/index.js
// module id = 490
// module chunks = 0